import { IconButton as MuiIconButton } from '@material-ui/core'
import React, { forwardRef } from 'react'
import { IconButtonProps } from './IconButtonProps'

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ color = 'secondary', ...restProps }, ref) => {
    return <MuiIconButton ref={ref} color={color} {...restProps} />
  },
)

IconButton.displayName = 'IconButton'
